import { IChangeGamePositionState } from './changeGamePositionContext';
import { ChangeGamePositionActionTypes, TChangeGamePositionActions } from './changeGamePositionActions';

export const changeGamePositionReducer = (
	state: IChangeGamePositionState,
	action: TChangeGamePositionActions,
): IChangeGamePositionState => {
	switch (action.type) {
		case ChangeGamePositionActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				positionsData: [],
			};
		case ChangeGamePositionActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				positionsData: [],
			};
		case ChangeGamePositionActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				positionsData: [],
			};
		case ChangeGamePositionActionTypes.SET_POSITIONS_DATA:
			return {
				...state,
				positionsData: action.payload.positionsData,
			};
		case ChangeGamePositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ChangeGamePositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL:
			return {
				...state,
				isVisibleAdditionalRestaurantsModal: action.payload.isVisibleAdditionalRestaurantsModal,
				isApplyToOne: action.payload.isApplyToOne,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
			};
		case ChangeGamePositionActionTypes.TOGGLE_APPLY_TO_ONE:
			return {
				...state,
				isApplyToOne: !state.isApplyToOne,
				selectedAdditionalRestaurants: [],
			};
		case ChangeGamePositionActionTypes.SET_ADDITIONAL_RESTAURANTS:
			return {
				...state,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
			};
		case ChangeGamePositionActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		default:
			return state;
	}
};
